import Abstract from "../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../render/render.js";

import {
  declinationNumber
} from "../../../../utils/declination-number.js";

import {
  PRODUCT_NUMBER_FORMS,
  SHOW_TEXT
} from "../lexicon.js";

const prepareButtonText = (productsNumber) => `${SHOW_TEXT} ${productsNumber}\u00A0${declinationNumber(productsNumber, PRODUCT_NUMBER_FORMS)}`;

const createShowProductsButtonTemplate = (productsNumber) => {
  const buttonText = prepareButtonText(productsNumber);

  return (
    `<div class="responsive-filter-show-button-wrapper">
      <button class="button button_responsive-filter-show">${buttonText}</button>
    </div>`
  );
};

export default class ShowProductsButton extends Abstract {
  constructor(productsNumber) {
    super();

    this._productsNumber = productsNumber;

    this._buttonElement = null;

    this._clickHandler = this._clickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getButtonElement() {
    if (!this._buttonElement) {
      this._buttonElement = this._element.querySelector(`.button`);
    }

    return this._buttonElement;
  }

  setNumber(value) {
    this._productsNumber = value;
    this.getButtonElement().textContent = prepareButtonText(this._productsNumber);
  }

  setClickHandler(callback) {
    this._callback.buttonClick = callback;
    this.getButtonElement().addEventListener(`click`, this._clickHandler);
  }

  _getTemplate() {
    return createShowProductsButtonTemplate(this._productsNumber);
  }

  _clickHandler() {
    this._callback.buttonClick();
  }
}
